'use client';

import AppLayout from '@/components/AppLayout';
import ArchiveSearch from './components/ArchiveSearch';

export default function SearchPage() {
  return (
    <AppLayout>
      <ArchiveSearch />
    </AppLayout>
  );
}
